import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import { useTranslation } from 'react-i18next';

import { useTransactionLocale } from '@/hooks/useTranslationLocale';

import MfaBeginEnrollOptionsForm from './components/MfaBeginEnrollOptionsForm';
import { useMfaBeginEnrollOptionsManager } from './hooks/useMfaBeginEnrollOptionsManager';

function MfaBeginEnrollOptionsScreen() {
  const { t } = useTranslation('mfaBeginEnrollOptions');
  useTransactionLocale();

  const { texts } = useMfaBeginEnrollOptionsManager();

  document.title = texts?.pageTitle || t('pageTitle');

  return (
    <BaseWrapper>
      <MfaBeginEnrollOptionsForm />
    </BaseWrapper>
  );
}

export default MfaBeginEnrollOptionsScreen;
